export enum ScriptStatus {
  LOADING = "loading",
  LOADED = "loaded",
  FAILED = "failed"
}
